import configs from '@/config'
import { createSharedFramePersistence, sharedFrameStorage } from '@/utils/indexedDB/shared-frame-cache.persistence'

// The gate and build identity for every cache entry shared between same-origin PowerPoint add-in
// frames. Callers pass this as SimpleCache's `persistence` and check the gate before opting a call in.
export const isSharedFrameCacheEnabled = () => Boolean(configs.isEnableAddinPowerpoint)

export const sharedFramePersistence = createSharedFramePersistence({
  storage: sharedFrameStorage,
  isEnabled: isSharedFrameCacheEnabled,
  appVersion: configs.sentryRelease || 'unversioned',
})
